'use client';

import { cn } from '@/lib/utils';
import { DropdownOverlayPanel } from '@/shared-ui/molecules/dropdown-overlay-panel';
import type { ComponentPropsWithoutRef, ReactNode, RefObject } from 'react';

export type SubmenuPanelItem = {
    itemKey: string;
    content: ReactNode;
};

type SubmenuPanelProps = ComponentPropsWithoutRef<'div'> & {
    activeItemKey?: string;
    panels: SubmenuPanelItem[];
    onClose: () => void;
    ignoreRefs?: Array<RefObject<HTMLElement | null>>;
};

export const SubmenuPanel = ({
    activeItemKey,
    panels,
    onClose,
    ignoreRefs,
    className,
    ...props
}: SubmenuPanelProps) => {
    const activePanel = panels.find((panel) => panel.itemKey === activeItemKey);

    return (
        <DropdownOverlayPanel
            open={Boolean(activePanel)}
            onClose={onClose}
            ignoreRefs={ignoreRefs}
            className={cn('hidden md:block absolute left-0 top-[40px] z-40 w-full bg-snk-bg-grey', className)}
            {...props}>
            <nav className="mx-auto max-w-[1280px] px-12 py-8" aria-label="Submenu panel">
                {activePanel?.content}
            </nav>
        </DropdownOverlayPanel>
    );
};
